<div mat-dialog-title class="cust-modal-title">
  <div class="prese_heading">
    <h2 class="m-0">Membership setting</h2>
  </div>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <!-- <div class="prese_button">
    </div> -->
</div>
<mat-dialog-content style="padding-bottom: 0px">
  <div class="pres_heading">
    <div class="manj_sectiom">
      <div class="shop_service_sec">
        <h4>Online membership apply</h4>
      </div>
      <div class="srd_fft">
        <mat-slide-toggle
          [checked]="toShowCheckOnlineMemberApply === 1"
          (change)="onToggleChange($event, 4)"
        ></mat-slide-toggle>
      </div>
    </div>
    <div class="manj_sectiom">
      <div class="shop_service_sec">
        <h4>Auto invoice creation</h4>
      </div>
      <div class="srd_fft">
        <mat-slide-toggle
          [checked]="toShowCheckInvoiceCreation === 1"
          (change)="onToggleChange($event, 3)"
        ></mat-slide-toggle>
      </div>
    </div>
    <div class="manj_sectiom">
      <div class="shop_service_sec">
        <h4>Send via WhatsApp</h4>
      </div>
      <div class="srd_fft">
        <mat-slide-toggle
          [checked]="toShowCheckWhatsapp === 1"
          (change)="onToggleChange($event, 1)"
        ></mat-slide-toggle>
      </div>
    </div>
    <div class="manj_sectiom">
      <div class="shop_service_sec">
        <h4>Send via Email</h4>
      </div>
      <div class="srd_fft">
        <mat-slide-toggle
          [checked]="toShowCheckEmail === 1"
          (change)="onToggleChange($event, 2)"
        ></mat-slide-toggle>
      </div>
    </div>
    <p
      class="set_heading"
      style="
        padding-bottom: 15px;
        border-bottom: 1px solid #f4f4f4;
        margin-bottom: 25px;
      "
    >
      Set the automatic membership invoice sending here. With setting ON, your
      members invoices going to be sent to their WhatsApp and Email
      automatically.
    </p>
    <div class="manj_sectiom">
      <div class="shop_service_sec">
        <h4>Enable default virtual meeting</h4>
      </div>
      <div class="srd_fft">
        <mat-slide-toggle
          [checked]="toShowCheckDefaultVirtualMeeting === 1"
          (change)="onToggleChange($event, 5)"
        ></mat-slide-toggle>
      </div>
    </div>
    <div *ngIf="toShowCheckDefaultVirtualMeeting === 1">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Default online session link</mat-label>
          <input
            [(ngModel)]="default_online_session_link"
            matInput
            type="text"
            placeholder="Default online session link"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>App download link (if there any)</mat-label>
          <textarea
            [(ngModel)]="default_online_session_app"
            matInput
            type="text"
            placeholder="Default online session link"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
    <p class="set_heading" style="padding-bottom: 5px">
      Set the default meeting information for your virtual online sessions.
      It'll appear automatically while adding a new member. Though you can
      change member specific.
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" style="margin-bottom: 12px">
  <button mat-button mat-dialog-close>Cancel</button>
  <button (click)="onSave()" mat-flat-button color="accent">Save</button>
</mat-dialog-actions>
